export default "__VITE_ASSET__XQZRH05D__"